var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service__center"},[_c('img',{staticClass:"pc__only",attrs:{"src":require("@/assets/img/service_center.jpg"),"alt":""}}),_c('img',{staticClass:"mb__only",attrs:{"src":require("@/assets/img/service_center_mo.jpg"),"alt":""}})])
}]

export { render, staticRenderFns }